'use strict'

import TimeRange from './timeRange'

let Api = function (router, store) {
    this.router = router
    this.store = store

    let intervals = []
    let timeouts = []

    this.request = function (method, route, parameters, success, error) {
        // @TODO: Migrate to fetch() to get rid of jQuery eventually
        jQuery.ajax({
            method: method,
            url: this.router.path(route, parameters),
            contentType: 'application/json',
            dataType: 'json',
            success: success,
            error: (response) => {
                // out of retention resources, i.e. traces
                if (response.status === 410) {
                    window.location.reload()
                }

                if (response.responseJSON &&
                    response.responseJSON.msg &&
                    (typeof response.responseJSON.msg === 'string')) {
                    // eslint-disable-next-line no-console
                    console.error("Error:", response.responseJSON)
                    if (error) {
                        error(response.responseJSON, response.responseJSON.data || null)
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.error("Unhandled Error:", response)

                    if (error && response.status > 0) {
                        error({ status: response.status, msg: response.statusText })
                    }
                }
            },
        })
    }

    this.requestContinuosly = function (method, route, parameters, success, error) {
        const refreshInterval = this.getReloadInterval(TimeRange.fromParameters(parameters))
        const refreshFunction = () => {
            this.request(method, route, parameters, success, error)
        }

        refreshFunction()
        intervals.push({
            refreshFunction: refreshFunction,
            refreshInterval: refreshInterval,
            interval: window.setInterval(refreshFunction, refreshInterval),
        })
    }

    this.trigger = (route, parameters, cacheKey = null, success = null) => {
        let routeKey = route.substr(route.indexOf('.') + 1)

        this.request(
            'GET',
            route,
            parameters,
            (data) => {
                this.store.dispatch({
                    type: routeKey + '.success',
                    id: cacheKey,
                    data: data,
                })

                if (success) {
                    success(data)
                }
            },
            (error) => {
                this.store.dispatch({
                    type: routeKey + '.error',
                    id: cacheKey,
                    error: error,
                })
            }
        )
    }

    this.triggerContinuously = (route, parameters, cacheKey = null) => {
        let routeKey = route.substr(route.indexOf('.') + 1)

        this.requestContinuosly(
            'GET',
            route,
            parameters,
            (data) => {
                this.store.dispatch({
                    type: routeKey + '.success',
                    id: cacheKey,
                    data: data,
                })
            },
            (error) => {
                this.store.dispatch({
                    type: routeKey + '.error',
                    id: cacheKey,
                    error: error,
                })
            }
        )
    }

    this.pauseRequests = function () {
        if (!intervals && !timeouts) {
            return
        }

        for (let i = 0; i < intervals.length; ++i) {
            window.clearInterval(intervals[i].interval)
            intervals[i].interval = null
        }

        for (let i = 0; i < timeouts.length; i++) {
            window.clearTimeout(timeouts[i])
        }

        timeouts = []
    }

    this.resumeRequests = function () {
        if (!intervals) {
            return
        }

        for (let i = 0; i < intervals.length; ++i) {
            if (intervals[i].refreshInterval > 2000) {
                let id = window.setTimeout(intervals[i].refreshFunction, 2000)
                timeouts.push(id)
            }

            intervals[i].interval = window.setInterval(
                intervals[i].refreshFunction,
                intervals[i].refreshInterval
            )
        }
    }

    this.clearContinuousRequests = function () {
        this.pauseRequests()
        intervals = []
    }

    this.getReloadInterval = function (timeRange) {
        return Math.max(
            60, // One minute
            Math.min(
                60 * 15, // 15 Minutes
                // Implicit divison by 60 because the value is used as seconds
                timeRange.asMinutes()
            )
        ) * 1000
    }
}

export default Api
